import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { DataTable } from '../components/DataTable';
import { KPICard } from '../components/KPICard';
import { TabView } from '../components/TabView';
import { mockPropertyTaxData, mockPropertyTaxRoll } from '../data/mockData';
const PropertyTaxReport = () => {
  const [view, setView] = useState('dashboard');
  const taxCollectedVsAssessed = mockPropertyTaxData.taxCollectedVsAssessed;
  const columns = [{
    header: 'Property ID',
    accessor: 'id'
  }, {
    header: 'UPI',
    accessor: 'upi'
  }, {
    header: 'Owner Name',
    accessor: 'ownerName'
  }, {
    header: 'Assessed Value',
    accessor: 'assessedValue'
  }, {
    header: 'Tax Due',
    accessor: 'taxDue'
  }, {
    header: 'Amount Paid',
    accessor: 'amountPaid'
  }, {
    header: 'Outstanding Balance',
    accessor: 'outstandingBalance'
  }, {
    header: 'Payment Status',
    accessor: 'paymentStatus'
  }];
  return <div className="p-6" data-id="element-210">
      <div className="flex justify-between items-center mb-6" data-id="element-211">
        <h1 className="text-2xl font-bold" data-id="element-212">
          Property Tax Roll & Collection Report
        </h1>
        <TabView tabs={[{
        id: 'dashboard',
        label: 'Dashboard'
      }, {
        id: 'data',
        label: 'Detailed Data'
      }]} activeTab={view} onChange={setView} data-id="element-213" />
      </div>
      {view === 'dashboard' ? <>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-8" data-id="element-214">
            <KPICard title="Total Properties" value={mockPropertyTaxData.totalProperties.toLocaleString()} change="+1.2%" isPositive={true} icon="home" color="blue" data-id="element-215" />
            <KPICard title="Total Assessed Value" value={`$${(mockPropertyTaxData.totalAssessedValue / 1000000).toFixed(1)}M`} change="+3.5%" isPositive={true} icon="trending-up" color="purple" data-id="element-216" />
            <KPICard title="Total Tax Assessed" value={`$${(mockPropertyTaxData.totalTaxAssessed / 1000000).toFixed(1)}M`} change="+2.8%" isPositive={true} icon="dollar-sign" color="green" data-id="element-217" />
            <KPICard title="Total Tax Collected" value={`$${(mockPropertyTaxData.totalTaxCollected / 1000000).toFixed(1)}M`} change="+4.2%" isPositive={true} icon="check-circle" color="teal" data-id="element-218" />
            <KPICard title="Delinquency Rate" value={`${mockPropertyTaxData.delinquencyRate}%`} change="-1.5%" isPositive={true} icon="alert-circle" color="red" data-id="element-219" />
          </div>
          <div className="bg-white p-4 rounded-lg shadow mb-8" data-id="element-220">
            <h2 className="text-lg font-semibold mb-4" data-id="element-221">
              Tax Collected vs. Assessed by Jurisdiction
            </h2>
            <ResponsiveContainer width="100%" height={400} data-id="element-222">
              <BarChart data={taxCollectedVsAssessed} data-id="element-223">
                <CartesianGrid strokeDasharray="3 3" data-id="element-224" />
                <XAxis dataKey="jurisdiction" data-id="element-225" />
                <YAxis tickFormatter={value => `$${(value / 1000000).toFixed(1)}M`} data-id="element-226" />
                <Tooltip formatter={value => `$${(value / 1000000).toFixed(1)}M`} data-id="element-227" />
                <Legend data-id="element-228" />
                <Bar dataKey="assessed" fill="#3b82f6" name="Tax Assessed" data-id="element-229" />
                <Bar dataKey="collected" fill="#10b981" name="Tax Collected" data-id="element-230" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-231">
            <div className="bg-white p-4 rounded-lg shadow" data-id="element-232">
              <h2 className="text-lg font-semibold mb-4" data-id="element-233">
                Collection Rate by Property Type
              </h2>
              <ResponsiveContainer width="100%" height={300} data-id="element-234">
                <BarChart data={mockPropertyTaxData.collectionRateByPropertyType} data-id="element-235">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-236" />
                  <XAxis dataKey="propertyType" data-id="element-237" />
                  <YAxis tickFormatter={value => `${value}%`} data-id="element-238" />
                  <Tooltip formatter={value => `${value}%`} data-id="element-239" />
                  <Legend data-id="element-240" />
                  <Bar dataKey="rate" fill="#8884d8" name="Collection Rate (%)" data-id="element-241" />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="bg-white p-4 rounded-lg shadow" data-id="element-242">
              <h2 className="text-lg font-semibold mb-4" data-id="element-243">
                Monthly Collection Trends
              </h2>
              <ResponsiveContainer width="100%" height={300} data-id="element-244">
                <BarChart data={mockPropertyTaxData.monthlyCollectionTrends} data-id="element-245">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-246" />
                  <XAxis dataKey="month" data-id="element-247" />
                  <YAxis tickFormatter={value => `$${(value / 1000000).toFixed(1)}M`} data-id="element-248" />
                  <Tooltip formatter={value => `$${(value / 1000000).toFixed(1)}M`} data-id="element-249" />
                  <Legend data-id="element-250" />
                  <Bar dataKey="amount" fill="#3b82f6" name="Amount Collected" data-id="element-251" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </> : <div className="bg-white p-4 rounded-lg shadow" data-id="element-252">
          <h2 className="text-lg font-semibold mb-4" data-id="element-253">Property Tax Roll</h2>
          <DataTable columns={columns} data={mockPropertyTaxRoll} pagination searchable exportable data-id="element-254" />
        </div>}
    </div>;
};
export default PropertyTaxReport;